var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "b-menu",
        { attrs: { activable: false } },
        [
          _c(
            "b-menu-list",
            { attrs: { label: "Administración SIGNAR" } },
            [
              _c("b-menu-item", {
                attrs: {
                  label: "Dashboard",
                  tag: "router-link",
                  exact: "",
                  icon: "tachometer-alt",
                  to: { name: "adminDashboard" },
                },
              }),
              _vm._v(" "),
              _c(
                "b-menu-item",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function (props) {
                        return [
                          _c("i", { staticClass: "fas fa-building fa-fw" }),
                          _vm._v(" Organizaciones\n        "),
                          _c("i", {
                            staticClass: "is-pulled-right fas",
                            class: props.expanded
                              ? "fa-caret-up"
                              : "fa-caret-down",
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: { name: "adminOrganizacionesListado" },
                      exact: "",
                      icon: "list",
                      label: "Listar",
                    },
                  }),
                  _vm._v(" "),
                  this.$store.getters.hasAnyRole(["lyris"])
                    ? _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: { name: "adminOrganizacionCrear" },
                          exact: "",
                          icon: "plus",
                          label: "Nuevo",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-menu-item",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function (props) {
                        return [
                          _c("i", { staticClass: "fas fa-file-alt fa-fw" }),
                          _vm._v(" Aspectos globales\n        "),
                          _c("i", {
                            staticClass: "is-pulled-right fas",
                            class: props.expanded
                              ? "fa-caret-up"
                              : "fa-caret-down",
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: { name: "adminAspectosGlobalesListado" },
                      exact: "",
                      icon: "list",
                      label: "Listar",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: { name: "adminAspectosGlobalesCrear" },
                      exact: "",
                      icon: "plus",
                      label: "Nuevo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-menu-list",
            { attrs: { label: "Avanzado" } },
            [
              _c("b-menu-item", {
                attrs: {
                  tag: "router-link",
                  to: { name: "lyrisConfigurarDemo" },
                  exact: "",
                  icon: "rocket",
                  label: "Nueva demo",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }